import styled from '@emotion/styled'
import { css } from '@emotion/react'
import { motion } from 'framer-motion'
import { bkgdHangulBottom, bkgdKanaBottom, bkgdWaveFooter, blue } from '.'

export const ChoosePlanSectionWrapper = styled.section<{ language?: string }>`
  display: grid;
  justify-items: center;
  background-image: url(${(props) => props.language === 'Korean' ? bkgdHangulBottom : bkgdKanaBottom});
`

export const DualLangEnglishSplit = styled.div<{ breakpoint: number }>`
  display: grid;
  grid-template-columns: auto auto;
  grid-column-gap: 10px;

  @media (max-width: ${({ breakpoint }) => breakpoint}px) { grid-template-columns: auto; }
`

export const PlansContainer = styled(motion.ul)`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 32px;
  padding: 96px 0 48px !important; // why do we need this for ul? I'm not sure - Mike
  
  @media (max-width: 1025px) { grid-template-columns: 1fr 1fr; }
  @media (max-width: 685px) { grid-template-columns: 1fr; }
`

export const AccountContainer = styled.form`
  display: grid;
  gap: 12px;
  padding: 24px 0 48px;
`

export const Input = styled.input`
  font-family: 'Outfit';
  font-weight: 300;
  font-size: 1.25rem;
  padding: 12px 24px;
  border-radius: 24px;
  border: 1px solid ${blue};
`

export const PaymentContainer = styled(motion.div)`
  display: grid;
  justify-self: stretch;
  padding: 24px 0 48px;
`

export const Disclaimer = styled.p`
  font-family: 'Outfit';
  color: grey;
`

export const Wave = styled.div`
  position: relative;
  top: 1px;
  margin-top: calc(100vw / 16);
  background-image: url(${bkgdWaveFooter});
  background-size: 100%;
  background-repeat: repeat-x;
  justify-self: stretch;
  height: calc(100vw / 12);
`

export const Footer = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  gap: 16px;
  background-color: #7BBBFF;
  justify-self: stretch;
  padding: 0 32px 32px;
`

export const FZLogo = styled.img`
  grid-column: 2;
  height: 50px;
  justify-self: center;
  
  @media (max-width: 1300px) { height: 40px; }
  @media (max-width: 800px) { height: 30px; }
  @media (max-width: 715px) { margin-top: 16px; }
`

export const TomokoLogin = styled.img`
  position: absolute;
  justify-self: end;
  align-self: end;
  height: 450px;

  @media (max-width: 1300px) { height: 350px; }
  @media (max-width: 800px) { height: 250px; }
  @media (max-width: 715px) { display: none }
`

const footerTextStyles = css`
  color: white;
  font-family: 'Outfit';
  font-weight: 200;
  font-size: 1.2rem;
  
  @media (max-width: 385px) { font-size: 1rem; }
`

export const Trademark = styled.p`
  ${footerTextStyles}
  grid-row: 2;
  align-self: end;

  @media (max-width: 715px) {
    grid-row: 3;
    grid-column: 2;
    justify-self: center;
    padding-top: 16px;
  }
`

export const FooterLinks = styled.div`
  ${footerTextStyles}
  grid-row: 2;
  grid-column: 2;
  justify-self: center;
`

export const FooterLink = styled.a`
  color: white;
  text-decoration: none;

  &:hover {
    color: white;
  }

`
